import {
  SCOPED_FINDING_RULE_REQUEST,
  FETCH_SCOPED_FINDING_RULE_SUCCESS,
  FETCH_SCOPED_FINDING_RULE_FAILURE,
  UPDATE_SCOPED_FINDING_RULE_FAILURE,
  CREATE_NEW_SCOPED_FINDING_SUCCESS,
  CREATE_NEW_SCOPED_FINDING_FAILURE,
  FETCH_HMI_SUCCESS,
  FETCH_HMI_FAILURE,
  FETCH_NODE_SUCCESS,
  FETCH_NODE_FAILURE,
  FETCH_FUNCTION_SUCCESS,
  FETCH_FUNCTION_FAILURE,
  SET_LOADING,
} from "../_constants";

const initialState = {
  loading: false,
  scopedFindingRule: "",
  error: null,
  hmi: [],
  node: [],
  function: [],
  componentLoading:true
};

export const scopedFindingRuleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SCOPED_FINDING_RULE_REQUEST:
      return {
        ...state,
        loading: true,
        scopedFindingRule: "",
        error: "",
      };

    case FETCH_SCOPED_FINDING_RULE_SUCCESS:
      return {
        ...state,
        loading: false,
        scopedFindingRule: action.payload,
        error: "",
      };
    case FETCH_SCOPED_FINDING_RULE_FAILURE:
      return {
        ...state,
        loading: false,
        scopedFindingRule: "",
        error: action.payload,
      };

    case UPDATE_SCOPED_FINDING_RULE_FAILURE: {
      return {
        ...state,
        error: action.payload,
        equation: null,
      };
    }

    case CREATE_NEW_SCOPED_FINDING_SUCCESS: {
      return {
        ...state,
        error: null,
      };
    }
    case CREATE_NEW_SCOPED_FINDING_FAILURE: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case FETCH_HMI_SUCCESS: {
      return {
        ...state,
        hmi: action.payload,
      };
    }
    case FETCH_HMI_FAILURE: {
      return {
        ...state,
        hmi:'',
        error: action.payload,
      };
    }
    case FETCH_NODE_SUCCESS: {
      return {
        ...state,
        node: [...action.payload,{name:"",number:""}],
      };
    }
    case FETCH_NODE_FAILURE: {
      return {
        ...state,
        node:'',
        error: action.payload,
      };
    }
    case FETCH_FUNCTION_SUCCESS: {
      return {
        ...state,
        function: [...action.payload,{name:"",number:""}],
      };
    }
    case FETCH_FUNCTION_FAILURE: {
      return {
        ...state,
        function:'',
        error: action.payload,
      };
    }
    case SET_LOADING: {
      return {
        ...state,
        componentLoading:action.payload
      };
    }
    default:
      return state;
  }
};
